import Vue from 'vue'
import VueRouter from 'vue-router'
import i18n from '@/i18n'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    title: () => i18n.t('routes.home'),
    showMenu: false,
    component:  () => import('@/views/home/index.vue')
  },
  {
    path: '/aboutus',
    name: 'aboutus',
    title: () => i18n.t('routes.aboutUs'),
    showMenu: false,
    component:  () => import('@/views/about/index.vue'),
    children: [
      {
        type: 'desc',
        path: '/aboutus/about-iase',
        title: () => i18n.t('routes.aboutIase'),
        component:  () => import('@/views/about/about.vue')
      },
      {
        type: 'desc',
        path: '/aboutus/network',
        title: () => i18n.t('routes.globalNetwork'),
        component:  () => import('@/views/about/network.vue')
      },
      {
        type: 'desc',
        path: '/aboutus/team',
        title: () => i18n.t('routes.leadershipTeam'),
        component:  () => import('@/views/about/team.vue')
      },
      {
        type: 'desc',
        path: '/aboutus/partner',
        title: () => i18n.t('routes.partners'),
        component:  () => import('@/views/about/partner.vue')
      },
    ]
  },
  {
    path: '/certification',
    name: 'certification',
    title: () => i18n.t('routes.professionalCertification'),
    showMenu: false,
    component:  () => import('@/views/certificate/index.vue'),
    children: [
      {
        type: '',
        path: '/certification/certificate',
        title: () => i18n.t('routes.aboutCertification'),
        component:  () => import('@/views/certificate/certificate.vue')
      },
      {
        type: 'title',
        path: '/Certification',
        title: () => i18n.t('routes.isbTitle')
      },
      {
        type: 'page',
        path: '/certification/isb-i-advisor-level',
        title: () => i18n.t('routes.isbIAdvisor'),
        component:  () => import('@/views/certificate/isb-i-advisor-level.vue')
      },
      {
        type: 'page',
        path: '/certification/isb-ii-specialist-level',
        title: () => i18n.t('routes.isbIISpecialist'),
        component:  () => import('@/views/certificate/isb-ii-specialist-level.vue')
      },
      {
        type: 'title',
        path: '/certification',
        title: () => i18n.t('routes.isfTitle')
      },
      {
        type: 'page',
        path: '/certification/isf-i-advisor-level',
        title: () => i18n.t('routes.isfIAdvisor'),
        component:  () => import('@/views/certificate/isf-i-advisor-level.vue')
      },
      {
        type: 'page',
        path: '/certification/isf-ii-specialist-level',
        title: () => i18n.t('routes.isfIISpecialist'),
        component:  () => import('@/views/certificate/isf-ii-specialist-level.vue')
      },
    ],
  },
  {
    path: '',
    name: '',
    title: () => i18n.t('routes.bookExam'),
    showMenu: false,
    type: 'link',
    href: 'https://iase-registration.esg-certifications.com/login'
  },
  {
    path: '/about-esg',
    name: 'about-esg',
    title: () => i18n.t('routes.aboutEsg'),
    showMenu: false,
    component:  () => import('@/views/about-esg/index.vue'),
  },
  {
    path: '/articles',
    name: 'articles',
    title: () => i18n.t('routes.news'),
    showMenu: false,
    component:  () => import('@/views/articles/index.vue'),
  },
  {
    path: '/detail',
    name: 'detail',
    title: () => i18n.t('routes.newsDetail'),
    showMenu: false,
    notShow: true,
    component:  () => import('@/views/articles/detail.vue'),
  },
  {
    path: '/useful-links',
    name: 'usefulLinks',
    title: () => i18n.t('routes.usefulLinks'),
    showMenu: false,
    notShow: true,
    component:  () => import('@/views/linkes/index.vue'),
  },
  {
    path: '/privacy',
    name: 'privacy',
    title: () => i18n.t('routes.privacyPolicy'),
    showMenu: false,
    notShow: true,
    component:  () => import('@/views/config/privacy.vue'),
  },
  {
    path: '/terms',
    name: 'terms',
    title: () => i18n.t('routes.termsConditions'),
    showMenu: false,
    notShow: true,
    component:  () => import('@/views/config/terms.vue'),
  },
  {
    path: '/contact',
    name: 'contact',
    title: () => i18n.t('routes.contactUs'),
    showMenu: false,
    component:  () => import('@/views/contact/index.vue'),
  },
  {
    path: '/esg-certification',
    name: 'esgCertification',
    title: () => i18n.t('routes.esgCertification'),
    showMenu: false,
    hide: true,
    component:  () => import('@/views/esg-certification/index.vue'),
  },
  {
    path: '/testimonials',
    name: 'testimonials',
    title: () => i18n.t('routes.testimonials'),
    showMenu: false,
    hide: true,
    component:  () => import('@/views/testimonials/index.vue'),
  },

  
]

const router = new VueRouter({
  routes
})
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0); // 滚动到顶部
  next();
});

export default router
